<div class="grid">
  <div class="col-12 mb-2">
    <div class="card title-card flex">
      <i class="pi pi-mobile title-card-icon"></i>
      <div>
        <p class="mb-0 text-3xl title">{{'model.devicesRemoved' | transloco}}</p>
        <p>{{'menu.descriptions.devicesRemoved' | transloco}}</p>
      </div>
    </div>
  </div>

  <div class="col-12">
    <div class="card">
      <div class="p-datatable p-component p-datatable-hoverable-rows">
        <div class="p-datatable-header">
          <div class="flex flex-column sm:flex-row justify-content-between">
            <div class="flex flex-column md:flex-row">
            </div>
            <div *ngIf="!filtersFilled" class="flex flex-column md:flex-row justify-content-end">
              <button
                [label]="'common.filters' | transloco"
                (click)="filtersVisible = !filtersVisible"
                pButton
                class="p-button-secondary"
                icon="pi pi-sliders-h"
              ></button>
            </div>
            <div *ngIf="filtersFilled" class="flex flex-column md:flex-row justify-content-end">
              <button
                [label]="'common.filters' | transloco"
                (click)="filtersVisible = !filtersVisible"
                pButton
                class="p-button-secondary filtersFilled"
                icon="pi pi-filter"
              ></button>
            </div>
          </div>
        </div>
        <p-table
          [(first)]="first"
          [(selection)]="selected"
          [(rows)]="rows"
          [value]="devices"
          [totalRecords]="totalDevices"
          [sortOrder]="-1"
          [autoLayout]="false"
          [paginator]="true"
          [rowsPerPageOptions]="[10,25,50]"
          [lazy]="true"
          (onLazyLoad)="onPageChange($event)"
          styleClass="p-datatable-striped"
          breakpoint="1600px"
          sortField="serialNumber"
          responsiveLayout="stack"
        >
          <ng-template pTemplate="header">
            <tr>
              <th class="selection-column-width" *ngIf="'ROLE_ADMIN' | userHasRole"></th>
              <th pSortableColumn="serialNumber">
                {{'attribute.serialNumber' | transloco}}
                <p-sortIcon field="serialNumber"></p-sortIcon>
              </th>
              <th pSortableColumn="tenant.name" *ngIf="'ROLE_SUPER_ADMIN' | userHasRole">
                {{'model.tenant' | transloco}}
                <p-sortIcon field="tenant.name"></p-sortIcon>
              </th>
              <th pSortableColumn="organization.name" *ngIf="'ROLE_ADMIN' | userHasRole: false">
                {{'model.organization' | transloco}}
                <p-sortIcon field="organization.name"></p-sortIcon>
              </th>
              <th pSortableColumn="deletedAt">
                {{'attribute.deletedAt' | transloco}}
                <p-sortIcon field="deletedAt"></p-sortIcon>
              </th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-device>
            <tr *ngIf="!loadingDevices" class="fadein">
              <td *ngIf="'ROLE_ADMIN' | userHasRole">
                <span class="p-column-title bold">{{'common.select' | transloco}}</span>
                <p-tableCheckbox [value]="device"></p-tableCheckbox>
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.serialNumber' | transloco}}</span>
                <p class="text-right md:text-left">{{device.serialNumber}}</p>
              </td>
              <td *ngIf="'ROLE_SUPER_ADMIN' | userHasRole">
                <span class="p-column-title bold">{{'model.tenant' | transloco}}</span>
                <a *ngIf="device.tenant" [routerLink]="['/management/tenants', device.tenant.uuid, 'details']">
                  {{device.tenant.name}}
                </a>
              </td>
              <td *ngIf="'ROLE_ADMIN' | userHasRole: false">
                <span class="p-column-title bold">{{'model.organization' | transloco}}</span>
                <a *ngIf="device.organization" [routerLink]="['/management/organizations', device.organization.uuid, 'details']">
                  {{device.organization.name}}
                </a>
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.dateLastValueReported' | transloco}}</span>
                <p class="text-right md:text-left">{{device.deletedAt | customDate}}</p>
              </td>
            </tr>
            <tr *ngIf="loadingDevices" class="fadein animation-delay-200 animation-fill-forwards no-opacity">
              <td class="row-height selection-column-width" *ngIf="'ROLE_SUPER_ADMIN' | userHasRole">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height w-12rem" *ngIf="'ROLE_ADMIN' | userHasRole: false">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td *ngIf="'ROLE_ADMIN' | userHasRole" class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="summary">
            <div class="flex align-items-center justify-content-between" *ngIf="totalDevices == 0">
              {{'pagination.empty' | transloco}}
            </div>
            <div class="flex align-items-center justify-content-between" *ngIf="totalDevices > 0">
              {{'pagination.showing' | transloco}} {{first + 1}}
              {{'pagination.to' | transloco}} {{(first + rows) >= totalDevices ? totalDevices : (first + rows)}}
              {{'pagination.of' | transloco}} {{totalDevices}}
              {{(totalDevices > 1 ? 'pagination.entries' : 'pagination.entry') | transloco}}
            </div>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>


</div>

<p-sidebar [(visible)]="filtersVisible" position="right" [baseZIndex]="10000" [style]="{'width':'25em'}">
  <div>
    <h2 style="margin-left: 10px;">{{'common.filters' | transloco}}</h2>
    <div>
      <div class="col-12">
        <div class="col-12 form-field">
          <label for="serialNumber">{{'attribute.serialNumber' | transloco}}</label>
        </div>
        <div class="col-12">
          <input
            [(ngModel)]="currentFilters.serialNumber"
            [focus]="filtersVisible"
            (keyup.enter)="filtersVisible = false; applyFilters()"
            appAutoFocus
            pInputText
            class="w-full"
            id="serialNumber"
            type="text"
            >
        </div>
      </div>
      <div class="col-12" *ngIf="authGuardService.superAdminRequired()">
        <div class="col-12 form-field">
          <label for="tenant">{{'model.tenant' | transloco}}</label>
        </div>
        <div class="col-12">
          <p-multiSelect
            [(ngModel)]="currentFilters.tenantUuids"
            [placeholder]="'select.generic' | transloco"
            [filter]="true" filterBy="name" display="chip" styleClass="w-full" appendTo="body"
            [options]="tenants"
            (onChange)="this.currentFilters.organizationUuids = []"
            id="tenant"
            optionLabel="name"
            optionValue="uuid"
          ></p-multiSelect>
        </div>
      </div>
      <div class="col-12" *ngIf="'ROLE_ADMIN' | userHasRole: false">
        <div class="col-12 form-field">
          <label for="organization">{{'model.organization' | transloco}}</label>
        </div>
        <div class="col-12">
          <p-multiSelect
            [(ngModel)]="currentFilters.organizationUuids"
            [placeholder]="'select.generic' | transloco"
            [options]="filteredOrganizations"
            [filter]="true"
            styleClass="w-full"
            id="organization"
            optionLabel="name"
            optionValue="uuid"
            filterBy="name"
            display="chip"
            appendTo="body"
          ></p-multiSelect>
        </div>
      </div>
      <div class="col-12">
        <div class="col-12 form-field">
          <label for="dateRanges">{{'attribute.deletedAt' | transloco}}</label>
        </div>
        <div class="col-12">
          <p-calendar
            [(ngModel)]="dateRanges"
            [firstDayOfWeek]="1"
            [readonlyInput]="false"
            styleClass="w-full"
            id="dateRanges"
            selectionMode="range"
            dateFormat="dd/mm/yy"
            appendTo="body"
            inputId="range"
          ></p-calendar>
        </div>
      </div>
      <div class="col-12">
        <p-button
          [label]="'common.filter' | transloco"
          [disabled]="!(
            currentFilters.serialNumber ||
            currentFilters.tenantUuids ||
            currentFilters.organizationUuids ||
            dateRanges
          )"
          (onClick)="filtersVisible = false; applyFilters()"
          styleClass="p-button-primary mx-2 mt-2"
          type="button"
        ></p-button>
        <p-button
          [label]="'common.clear' | transloco"
          (click)="resetFilters(); filtersVisible = false;"
          styleClass="p-button-danger"
          type="button"
        ></p-button>
      </div>
    </div>
  </div>
</p-sidebar>
